export class Point {
    constructor() {
    }

    type = 'Point';
    coordinates = [];
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/point.ts